
   
<div style="height:100vh; text-align: center; display: flex; flex-direction: column; justify-content: center; font-size: 400%;">Kill Me Heal Me- Episode 1 </div>
<div>
        <div id="story"><div class="grid">
            
            <header>
                <h1 data-aos="flip-left"
                data-aos-anchor="#example-anchor"
                data-aos-offset="500"
                data-aos-duration="2500">Kill Me,heal Me!</h1>
            </header>
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img style="height: 70vh;" src={{Comics[0].payload.doc.data().Image}} >
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[0].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[1].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[1].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[2].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[2].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[3].payload.doc.data().Image}} >
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[3].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[4].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[4].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[5].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[5].payload.doc.data().Message}}"</p>

        </div></div>

        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[6].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[6].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[7].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[7].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[8].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[8].payload.doc.data().Message}}"</p>

            
        </div></div>

        <div id="story"><div class="grid">
            
         
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img style="height: 70vh;" src={{Comics[9].payload.doc.data().Image}} >
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[9].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[10].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[10].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[11].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[11].payload.doc.data().Message}}"</p>

            
        </div></div>
        

        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[12].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[12].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[13].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[13].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[14].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[14].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[15].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[15].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[16].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[16].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[17].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[17].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[18].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[18].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[19].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[19].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[20].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[20].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[21].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[21].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[22].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[22].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[23].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[23].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[24].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[24].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[25].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[25].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[26].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[26].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[27].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[27].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[28].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[28].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[29].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[29].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[30].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[30].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[31].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[31].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[32].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[32].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[33].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[33].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[34].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[34].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[35].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[35].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[36].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[36].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[37].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[37].payload.doc.data().Message}}</p>
            <figure data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000" class="fig fig--3" style="--aspect-ratio: 3/4;">
                <img src={{Comics[38].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-out-right" data-aos-duration="1500">{{Comics[38].payload.doc.data().Message}}"</p>

            
        </div></div>
        <div id="story"><div class="grid">
            
        
            <figure data-aos="zoom-in-left" data-aos-duration="5000" class="fig fig--1" style="--aspect-ratio: 3/4;">
                <img src={{Comics[39].payload.doc.data().Image}} alt='Ada lovelace'>
            </figure>
            <p data-aos="zoom-in-right" data-aos-duration="1500">{{Comics[39].payload.doc.data().Message}}</p>
            <figure data-aos="zoom-out-left" class="fig fig--2" style="--aspect-ratio: 4/3;">
                <img src={{Comics[40].payload.doc.data().Image}}>
            </figure>
            <p data-aos="zoom-in-up"
            data-aos-duration="1500">{{Comics[40].payload.doc.data().Message}}</p>
          
        </div></div>
    </div>
    
  

